import type { BannerRichTextProps } from '../../../components/BannerRichText/BannerRichText';
import { ComponentType } from '../../registries/types/propTypes';
import transformRichTextComponent from '../rich-text-component-transformer/richTextComponentTransformer';
import { CMSTransformerDataType } from '../../types/common';
const transformBannerRichText = (data: CMSTransformerDataType): BannerRichTextProps => {
  const bannerRichText = Array.isArray(data.banner_rich_text_component)
    ? data.banner_rich_text_component[0]
    : data.banner_rich_text_component;
  const richTextComponentData = transformRichTextComponent(bannerRichText);

  /*Removing properties which are getting associated after transformation due to this function transformRichTextComponent, 
  these properties are associated at component root level*/
  delete richTextComponentData.sanitize;
  delete richTextComponentData.sanitizationConfig;

  return {
    componentType: ComponentType.banner_rich_text_component,
    title: bannerRichText.display_title,
    images: bannerRichText.image.images.map((image: CMSTransformerDataType) => ({
      url: image.image.url,
      altText: image.alt_text,
      viewport: image.viewport,
    })),
    sanitize: bannerRichText.sanitize ?? false,
    sanitizationConfig: bannerRichText.sanitizationConfig ?? {},
    richTextComponentData,
  };
};

export default transformBannerRichText;
